import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import ContentGrid from "./components/content-grid/ContentGrid";
import LeftSidebar from "./components/left-sidebar/LeftSidebar";
import { useMainMenu } from "../../hooks/use-main-menu";
import ReferralBar from "./components/referral-bar/ReferralBar";
import BattlepassBanner from "./components/battlepass-banner/BattlepassBanner";
import { MENU_SCREEN } from "../../menu.types";

const sidebarVariants: any = {
  hidden: { opacity: 0, x: -40 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1], delay: 0.15 },
  },
};

const gridVariants: any = {
  hidden: { opacity: 0, x: 40 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1], delay: 0.25 },
  },
};

export const HomeScreen = () => {
  const { activeScreen, changeScreen, referral } = useMainMenu();
  const shouldReduceMotion = useReducedMotion();

  return (
    <div className="flex flex-col gap-4 h-full 2560px:h-auto">
      <div className="flex gap-4 flex-1 min-h-0">
        <motion.div
          className="overflow-y-auto scrollbar-1 pr-2"
          {...(shouldReduceMotion
            ? {}
            : {
                variants: sidebarVariants,
                initial: "hidden",
                animate: "visible",
              })}
        >
          <LeftSidebar
            activeScreen={activeScreen}
            changeScreen={changeScreen}
          />
        </motion.div>
        <motion.div
          className="flex-1 min-w-0 flex"
          {...(shouldReduceMotion
            ? {}
            : {
                variants: gridVariants,
                initial: "hidden",
                animate: "visible",
              })}
        >
          <ContentGrid changeScreen={changeScreen} />
        </motion.div>
      </div>

      <div className="grid grid-cols-2 gap-5">
        {referral?.code && (
          <ReferralBar
            onAction={() => changeScreen(MENU_SCREEN.Referral)}
            code={referral.code}
            actionCtaText="ACCESEAZA"
          />
        )}

        <BattlepassBanner />
      </div>
    </div>
  );
};

export default HomeScreen;
